import React, { useState } from 'react'
import styled from 'styled-components'
import { XL } from '@zendeskgarden/react-typography'
import { Paragraph, Title, Well } from '@zendeskgarden/react-notifications'
import { decideDayStatus } from './utils'
import IncidentModalContent from './IncidentModalContent'
import { Modal, Close } from '@zendeskgarden/react-modals'
import { Button } from "@zendeskgarden/react-buttons"
import { Row } from '@zendeskgarden/react-grid'
import StatusIcon from './StatusIcon'
import { decideIncidentStatus } from '../../utils/incident'

const StatusBannerWell = styled(Well)`
  width: 950px
`

const StyledBannerTitle = styled(Title)`
`

const PutABirdOnItImage = styled.img`
  height: 172px
  width: 358px
  float: right
`

const StyledBannerTitleText = styled(XL)`
`

const BannerParagraph = styled(Paragraph)`
`

const StyledIncidentModalContent = styled(IncidentModalContent)`
`

const Spacer = styled.div`
  padding-right: 4px
`

const StyledModalTitle = styled.div`
  overflow: hidden
  text-overflow: ellipsis
  max-width: 70%
  white-space: nowrap
  text-align: left
`
const StyledModalIconDiv = styled.div`
  padding-right: 5px
  padding-top: 1px
  padding-left: 10px
`

const ServiceSummaryBanner = ({ incidents, subdomain, inTimezone, bannerValue }) => {
  const scope = (subdomain !== '') ? subdomain : 'Zendesk'
  const currentIncidents = incidents.filter(ins => (ins.attributes.resolvedAt === null) && (ins.attributes.internalToolsOnly === false)).slice(0, 6)
  const status = decideDayStatus(currentIncidents)

  const [modalIncident, setModalIncident] = useState(null)

  const bannerBody = () => {
    function modalTrigger(incident, inTimezone) {
      return (
        <div>
          <Row>
            <StyledModalIconDiv>
              <StatusIcon status={decideIncidentStatus(incident.attributes)}/>
            </StyledModalIconDiv>
            <StyledModalTitle>
              {incident.attributes.name}
            </StyledModalTitle>
            <Spacer/>
            <Button onClick={() => {setModalIncident(incident)}} link>
              View Details
            </Button>
          </Row>
          {
            modalIncident && <Modal onClose={() => setModalIncident(null)} large animate>
              <StyledIncidentModalContent
                key={`${modalIncident.id.toString()}`}
                incident={modalIncident}
                inTimezone={inTimezone}
              >
              </StyledIncidentModalContent>
              <Close aria-label="Close modal" />
            </Modal>
          }
        </div>
      )
    }

    return (
      <div>
        <PutABirdOnItImage src="img/maintenance-toolbox.svg" alt="bird on a toolbox"/>
        {currentIncidents.map(incident => (
          <BannerParagraph key={incident.id}>
            {modalTrigger(incident, inTimezone)}
          </BannerParagraph>
        ))}
      </div>
    )
  }

  const bannerText = () => {
    if (status !== 'normal') {
      return `Active incidents with ${scope}`
    } else if (bannerValue.length > 0) {
      return bannerValue
    } else {
      return `No incidents with ${scope}`
    }
  }

  return (
    <StatusBannerWell>
      <StyledBannerTitle>
        <StyledBannerTitleText>
          <div>{bannerText()}</div>
        </StyledBannerTitleText>
      </StyledBannerTitle>
      {status !== "normal" ? bannerBody() : null}
      {status !== "normal" && bannerValue &&
        <Paragraph>
          {bannerValue}
        </Paragraph>
      }
    </StatusBannerWell>
  )
}

export default ServiceSummaryBanner
